import type { PlatformAdapter } from './PlatformAdapter'

/** Plain web build: no SDK, no ads. */
export class WebAdapter implements PlatformAdapter {
  init(): Promise<void> {
    return Promise.resolve()
  }

  gameplayStart(): void {}

  gameplayStop(): void {}

  showAd(): Promise<void> {
    return Promise.resolve()
  }
}
